var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditPicture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editPicture",
    transform: "translate(-181.83 -309.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1297",
    "data-name": "Ellipse 1297",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(182.83 310.5)",
    fill: "#39be9d",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "editPicture-2",
    "data-name": "editPicture",
    transform: "translate(-155.712 -225.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_10",
    "data-name": "Union 10",
    d: "M1.744,12A1.744,1.744,0,0,1,0,10.256V2.809A1.743,1.743,0,0,1,1.744,1.067H4.585a.679.679,0,0,1,0,1.358H1.744a.386.386,0,0,0-.386.383v7.447a.386.386,0,0,0,.386.386H9.189a.385.385,0,0,0,.386-.386V7.416a.679.679,0,0,1,1.358,0v2.84A1.744,1.744,0,0,1,9.189,12Zm2.127-3.19a.682.682,0,0,1-.681-.682V6a.68.68,0,0,1,.2-.482L8.71.2a.682.682,0,0,1,.961,0L11.8,2.329a.674.674,0,0,1,0,.961L6.48,8.611a.7.7,0,0,1-.482.2Zm.681-2.529V7.448H5.719l4.637-4.64L9.189,1.641Z",
    transform: "translate(345.041 541.981)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPicture);
export default __webpack_public_path__ + "static/media/editPicture.61712bd279d93c74e12fd744544a3961.svg";
export { ForwardRef as ReactComponent };